export function chantierRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_CHANTIER_START":           
        case "FETCH_CHANTIERS_START":                                 
        case "UPDATE_CHANTIER_START":                                 
        case "ADD_SPENDING_TO_CHANTIER_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_CHANTIER_FULFILLED":           
        case "FETCH_CHANTIERS_FULFILLED":                                 
        case "UPDATE_CHANTIER_FULFILLED":                                 
        case "ADD_SPENDING_TO_CHANTIER_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_CHANTIER_ERROR":
        case "FETCH_CHANTIERS_ERROR":
        case "UPDATE_CHANTIER_ERROR":
        case "ADD_SPENDING_TO_CHANTIER_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}